/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoggerHelper as LoggerHelperShared } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { LoggerOverlayData } from '@bcp-channels-sharedcomponents-reactjs/core/dist/modules/loggerOverlay/loggerOverlay.types';
import { LoggerConfig } from '@configs';
import { PassLoggerOverlayProvider } from '@modules';

interface LoggerOptions {
	overlay?: {
		show?: boolean;
	};
	api?: {
		log?: boolean;
	};
}

export class LoggerHelper extends LoggerHelperShared {
	static log(module: string, message: any, data?: any, options?: LoggerOptions) {
		this.middleware(message, data, options, () => LoggerHelperShared.log(module, message, data || ''));
	}

	static error(module: string, message: any, data?: any, options?: LoggerOptions) {
		this.middleware(message, data, options, () => LoggerHelperShared.error(module, message, data || ''));
	}

	private static middleware(message: any, data?: any, options?: LoggerOptions, callback?: () => void) {
		const logData: LoggerOverlayData = {
			version: LoggerConfig.buildNumber,
			location: window.location.href,
			message: message,
			data,
		};

		options?.overlay?.show && PassLoggerOverlayProvider.showOverlay(logData);

		// options?.api?.log && ApiClient.api.log({});

		return callback?.();
	}
}
